import React from "react";
import { cn } from "@/lib/utils";
import { Container } from "@/components/layout/Container";

/**
 * Section — vertical rhythm wrapper with light/dark tone handling.
 * tone: "light" | "offwhite" | "dark"
 */
const toneStyles = {
  light: "bg-strato-white text-strato-graphite",
  offwhite: "bg-strato-offwhite text-strato-graphite",
  dark: "dark bg-strato-nearblack text-white",
};

export const Section = React.forwardRef(
  (
    { id, tone = "light", className, containerClassName, children, ...props },
    ref,
  ) => {
    return (
      <section
        id={id}
        ref={ref}
        data-testid={id ? `${id}` : undefined}
        className={cn(
          "relative py-16 sm:py-20 lg:py-28",
          toneStyles[tone],
          className,
        )}
        {...props}
      >
        <Container className={containerClassName}>{children}</Container>
      </section>
    );
  },
);
Section.displayName = "Section";

/**
 * SectionHeading — micro-label + title + optional description.
 */
export const SectionHeading = ({
  microLabel,
  title,
  description,
  align = "left",
  className,
}) => {
  return (
    <div
      className={cn(
        "max-w-2xl",
        align === "center" && "mx-auto text-center",
        className,
      )}
    >
      {microLabel ? (
        <p className="strato-micro text-strato-blue">{microLabel}</p>
      ) : null}
      {title ? (
        <h2 className="mt-4 font-display text-3xl font-medium tracking-[-0.02em] leading-[1.1] sm:text-4xl lg:text-[2.75rem]">
          {title}
        </h2>
      ) : null}
      {description ? (
        <p className="mt-4 max-w-[58ch] text-base leading-[1.6] text-muted-foreground">
          {description}
        </p>
      ) : null}
    </div>
  );
};
